var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40008 7.1999H15.6001M8.40008 10.7999H15.6001M8.40008 14.3999H12.0001M6.5998 2.3999H17.4C18.7255 2.3999 19.8 3.47445 19.8 4.79995L19.7998 19.2C19.7997 20.5254 18.7252 21.5999 17.3997 21.5999L6.5997 21.5998C5.27421 21.5998 4.1997 20.5253 4.19971 19.1998L4.1998 4.79989C4.19981 3.47441 5.27432 2.3999 6.5998 2.3999Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericJobIcon);
export default __webpack_public_path__ + "static/media/generic-job-icon.888e8e3ef5cb4df75fbabea8569f10dc.svg";
export { ForwardRef as ReactComponent };